const main = {
  topbar: {
    home: '主頁',
    setting: '設置',
    language: '繁中',
    user: '用户',
    systemSetting: '系統設定',
    version: '版本'
  },
  menu: {
    homepage: '主頁'
  },
  user: {
    user: '用户',
    loginTime: '登入時間',
    logout: '登出',
    profile: '個人信息'
  },
  forget: {
    back: '返回',
    next: '下一步',
    Account_Recovery: '帳號恢復',
    Recover_Account_Password: '恢復帳戶密碼'
  },
  signIn: '登入',
  account: '帳號',
  password: '密碼',
  rememberMe: '記住我',
  forgetPassword: '忘記密碼?',
  learnMore: '瞭解詳情',
  contactTo: '請聯繫 ',
  error: '错误',
  licenseVerificationFailed: '我們無法驗證此服務的授權訊息。',
  limitationVerificationFailed: 'SPEC 文件不合法。',
  returnToLogin: '返回登入'
};

const systemSetting = {
  uiTheme: '介面主題',
  timeZone: '時區',
  about: '關於',
  version: '版本',
  newPwdNotSame: '兩次輸入的新密碼不一致',
  changePwdSuccess: '修改密碼成功',
  changePwdFailed: '修改密碼失敗',
  oldPasswordError: '修改密碼失敗，舊密碼錯誤',
  choseTheme: '選擇主題',
  choseZone: '選擇時區',
  passwordLengthErr: '密碼不能為空，且長度必須在 8 至 20 字元',
  passwordError: '密碼不正確',
  passwordPolicyErr: '新密碼不符合規則 <br/>' + '密碼原則：<br/>' +
  '8 至 20 個字元 <br/>' +
  '至少1個數字 <br/>' +
  '至少1個小寫字母 <br/>' +
  '至少1個大寫字母 <br/>' +
  '至少1個特殊字元 <br/>' +
  '禁止空格（space）或定位（tab）字元',
  productInfo: {
    uploadConfig: '將zip檔點擊上傳',
    uploadConfigSuccess: '上傳成功',
    uploadConfigFailed: '上傳失敗',
    productConfig: '產品設定',
    productDetail: '產品信息',
    productName: '產品名稱',
    productFavicon: 'favicon',
    pageTitle: '文件標籤名稱',
    loginPage: '登入頁',
    loginPageTitleUseText: '使用文字主標',
    loginPageTitle: '文字主標',
    loginPageSubtitle: '文字副標',
    loginPageTitleImage: '圖片主標',
    loginPageTitleLogoImage: '圖片 Logo',
    loginPageBackground: '背景',
    loginPageBackground_1280: '背景 (1280px)',
    loginPageBackground_1920: '背景 (1920px)',
    loginPageBackground_max: '背景 (max)',
    showForgetPwd: '顯示\'忘記密碼\'',
    showLoginType: '顯示\'登入類型\'',
    mainPage: '主頁',
    mainLogoImage: '橫幅 Logo',
    mainLogoTitle: '橫幅主標',
    mainHeaderBgcolor: '橫幅背景色',
    enablePowerBy: '顯示 \'Powered By\'',
    powerByLogo: '\'Powered By\' Logo 圖片',
    enableWatermark: '顯示水印',
    watermarkLogo: '水印 Logo 圖',
    goToForum: '顯示開啟論壇',
    goToDocument: '顯示開啟文件'
  }
};

const versionHistory = {
  VersionHistory: '版本紀錄',
  version: '版本',
  date: '日期',
  description: '描述',
  upgrade: '升級'
}

const userProfile = {
  username: '用戶名稱',
  email: '用戶 ID ',
  role: '角色',
  changePassword: '更改密碼',
  oldPassword: '舊密碼',
  newPassword: '新密碼',
  confirmPassword: '確認密碼',
  cancel: '取消',
  save: '保存'
};

const orgList = {
  name: '組織名稱',
  id: '組織ID',
  sketchboard: '繪圖板',
  dataSource: '數據源',
  createdBy: '創建者',
  role: '角色',
  user: '用戶',
  search: '搜尋組織',
  enterOrgName: '請輸入組織名稱',
  add: '+ 添加組織',
  limit: '0 個組織可添加',
  limitMessage: '標準版最多可以包含{num}個組織。要無限組織（以及更多），請升級到專業版。',
  view: '查看',
  manage: '管理',
  delete: '刪除',
  save: '保存',
  cancel: '取消',
  alarm: '確認刪除？(請再次輸入組織名稱)',
  rename: '重新命名',
  remind: '提示',
  message: {
    emptyName: '組織名稱不能為空',
    nameLengthLimit: '名稱長度限制為 64 字元',
    deleteSuccess: '刪除組織成功',
    deleteFailed: '刪除組織失敗',
    addSuccess: '增加組織成功',
    addFailed: '增加組織失敗',
    addFailedRepeatName: '組織名稱已被使用中，請輸入新的名稱',
    modifySuccess: '修改組織成功',
    modifyFailed: '修改組織失敗',
    getDataError: '獲取組織訊息失敗',
    getTotalCountError: '獲取組織總數量失敗',
    policyErr: '組織名稱格式不正確'
  }
};

const dataSource = {
  chose: '請選擇',
  name: '數據源名稱',
  type: '數據源類型',
  search: '搜尋數據源',
  add: '+ 添加數據源',
  importDataSource: '導入數據源',
  advanced: '高級',
  plugin: '插件',
  manage: '管理',
  edit: '編輯',
  delete: '刪除',
  save: '保存',
  confirm: '確認',
  cancel: '取消',
  alarm: '確認刪除該數據源？',
  remind: '提示',
  nodeRed: 'Data-Director',
  importConfig: '導入配置',
  exportConfig: '導出配置',
  importPlugin: '上傳數據源插件',
  more: '更多選項',
  message: {
    emptyName: '數據源名稱不能為空',
    deleteSuccess: '刪除數據源成功',
    deleteFailed: '刪除數據源失敗',
    addSuccess: '增加數據源成功',
    addFailed: '增加數據源失敗',
    modifySuccess: '修改數據源成功',
    modifyFailed: '修改數據源失敗',
    getDataError: '獲取數據源訊息失敗',
    policyErr: '數據源名稱格式不正確，不可包含特殊符號',
    emptyType: '數據源類型不能為空',
    emptyUrl: 'URL 不能為空',
    repeatName: '數據源名稱重複',
    connectSuccess: '數據連接成功',
    connectFail: '數據連接失敗',
    nameLengthLimit: '名稱長度限制為 64 字元',
    importPluginSuccess: '導入插件成功',
    importPluginFailed: '導入插件成功',
    deletePluginSuccess: '刪除插件成功',
    deletePluginFailed: '刪除插件失敗',
    downloadPluginFailed: '下載插件失敗',
    existedPlugin: '插件已存在',
    invalidPlugin: '插件無效',
    invalidZIPFile: '無效的ZIP文件',
    invalidPluginContent: '插件內容無效',
    PluginTooLarge: '插件文件太大',
    notEnableNodeRed: 'Data-Director 服務並未啟動',
    importDataSourceSuccess: '導入數據源配置成功',
    importDataSourceFailed: '導入數據源配置失敗',
    existedDataSourceName: '數據源名稱重復，是否進行覆蓋',
    emptyUser: '用戶名不能為空',
    emptyPassword: '密碼不能為空',
    emptyPort: '端口號不能為空',
    emptyDatabase: '數據庫不能為空',
    emptySslMode: 'SSL Mode 不能為空',
    emptyIvsid: 'IVSID 不能為空',
    copySuccess: '複製成功'
  }
};

const user = {
  addUserInfo: '添加用戶',
  alarm: '確認刪除該用戶？',
  remind: '提示',
  name: '用戶名',
  type: '用戶類型',
  search: '搜尋用戶',
  addUser: '+ 添加用戶',
  limit: '0 個用戶可添加',
  limitMessage: '標準版最多可以包含{num}個用戶。要無限用戶（以及更多），請升級到專業版。',
  manage: '管理',
  edit: '編輯',
  delete: '刪除',
  save: '保存',
  cancel: '取消',
  email: '用戶 ID ',
  select: '請選擇',
  organization: '組織',
  addOrg: '+ 增加',
  selectOrg: '請選擇組織',
  selectRole: '請選擇角色',
  enterEmail: '請輸入用戶 ID ',
  enterPassword: '請輸入密碼',
  enterPasswordAgain: '請重新輸入密碼',
  enterUserName: '請輸入用戶名稱',
  admin: '管理者',
  password: '密碼',
  message: {
    repeatOrg: '組織選擇重複，請重新選擇',
    emptyOrg: '組織不能為空',
    emptyRole: '用戶類型不能為空',
    emptyEmail: '用戶 ID 不能為空',
    emptyPassword: '密碼不能為空',
    inconsistentPassword: '兩次輸入密碼不一致',
    deleteSuccess: '刪除用戶成功',
    deleteFailed: '刪除用戶失敗',
    addFailedRepeatName: '刪除用戶失敗，重複的用戶 ID',
    deleteFailedLastUser: '組織最少需要保留一位 Admin 用戶',
    modifySuccess: '修改用戶成功',
    modifyFailed: '修改用戶失敗',
    addSuccess: '增加用戶成功',
    addFailed: '增加用戶失敗',
    duplicateKey: '增加用戶失敗，該用戶已存在',
    unknownUser: '未能找到該用戶，請先至主頁用戶管理新增該用戶',
    getDataError: '獲取用戶信息失敗',
    getUserOrgDataError: '獲取用戶綁定信息失敗',
    deleteSelf: '您不能刪除您自己',
    emptyUserNameEmail: '用戶名稱和用戶 ID 不能為空值',
    emailPolicyErr: '用戶 ID 格式不正確',
    namePolicyErr: '用戶名稱格式不正確',
    nameLengthLimit: '名稱長度限制為 64 字元'
  }
};

const sketchboard = {
  search: '搜尋繪圖板',
  add: '+ 添加繪圖板',
  add3D: '+ 添加 3D繪圖板',
  spaceEditor: '空間編輯器',
  limit: '0 個{type}繪圖板可添加',
  limitMessage: '標準版最多可以包含{num}{type}個繪圖板。要無限{type}繪圖板（以及更多），請升級到專業版。',
  name: '繪圖板名稱',
  displayType: '繪圖板類型',
  createdBy: '創建者',
  view: '查看',
  edit: '編輯',
  message: {
    getDataError: '獲取繪圖板信息失敗'
  }
};

const body = {
  home: '組織管理',
  organization: '組織',
  setting: '設定',
  orgList: '組織列表',
  userManagement: '用戶管理',
  sketchboard: '繪圖板',
  dataSource: '數據源',
  user: '用戶',
  systemSetting: '系統設定',
  userProfile: '用戶偏好設定',
  version: '版本',
  menu: '選單'
};

const homePage = {
  title: 'Home/Organization chs'
};

const glb = {
  loading: '加載中',
  header: '頂欄',
  aside: '側邊欄',
  main: '主區域',
  date: {
    timeQuantum: '時間段',
    to: '至',
    startDate: '開始日期',
    endDate: '結束日期'
  },
  search: '搜尋',
  placeholder: '請選擇',
  apply: '套用',
  cancel: '取消'
};

const menu = {
  menuList: '選單列表',
  viewPage: '瀏覽',
  saveMenu: '存檔',
  addNode: '添加節點',
  selectLangDetail: '設定項目語言顯示名稱及 sketchboard 連結',
  folder: '資料夾',
  file: '項目',
  menuName: '項目名稱',
  sketchboardLink: 'Sketchboard 連結',
  defaultOpen: '預設開啟',
  logo: 'Logo',
  logoImage: '圖片',
  limitMessage: '對於客製化 logo，請升級到專業版。',
  logoSrc: '路徑',
  logoDescript: '描述',
  menu: '選單',
  width: '寬度',
  modify: '修改',
  cancel: '取消',
  reset: '重設',
  openMenu: '預設開啟',
  showIcon: '顯示圖示',
  openSetting: '開啟設定',
  frameSetting: '框架設定',
  changeImage: '修改',
  clearImage: '清除',
  language: '語言',
  openLanguage: '開啟語言切換',
  defaultLang: '預設語言',
  view: '預覽',
  openLayerView: '疊加層預覽',
  message: {
    addSuccess: '存檔成功',
    addFailed: '存檔失敗',
    loadFailed: '讀取列表失敗'
  }
}

const orgSetting = {
  bimEnable: '啟用 BIM',
  viewLogin: '預覽登入',
  outsideResource: '外部資源',
  saveMenu: '儲存偏好',
  message: {
    addSuccess: '存檔成功',
    addFailed: '存檔失敗',
    loadFailed: '讀取失敗，使用預設'
  }
}

const en = {
  main,
  body,
  homePage,
  glb,
  orgList,
  dataSource,
  user,
  sketchboard,
  userProfile,
  systemSetting,
  versionHistory,
  menu,
  orgSetting
};

export default en



// WEBPACK FOOTER //
// ./src/js/lang/tw.js